import { imageUrlBuilder } from '@sans-souci/services/sanity-service'
import { MediaFieldType } from '@sans-souci/models'

export const seoImageLoader = (
  media?: MediaFieldType,
  altText?: string,
): { url: string; width: number; height: number; alt: string } | null => {
  const type = media?.mediaPayload?.type

  if (!type) {
    return null
  }

  const width = 1200
  const height = 630

  switch (type) {
    case 'sanity-image':
      if (!media.mediaPayload.image?.asset) {
        return null
      }
      return {
        url: imageUrlBuilder
          .image(media.mediaPayload.image)
          .width(width)
          .height(height)
          .url(),
        width,
        height,
        alt: altText ?? media.mediaPayload.image.alt ?? '',
      }
    default:
      return null
  }
}
